import React from 'react'
import PointsCard from './PointsCard'
import RecommendationCard from './RecommendationCard'
import Row from 'react-bootstrap/Row'

export default function PointsSection() {
  return (
    <Row className="row-eq-height">
      <PointsCard />
      {/*<RecommendationCard />*/}
    </Row>
  )
}
